import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { FlowSteps } from './FlowSteps';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-zinc-100" data-id="element-309" data-mp="cng4emis5haj">
      <div className="max-w-6xl mx-auto" data-id="element-310" data-mp="cm52ytct4lml">
        <div className="text-center mb-16" data-id="element-311" data-mp="7p69md0ywipg">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-4 text-zinc-950" data-id="element-312" data-mp="7nbmcs284ei7">
            The 6-in-1 MMA Coach Ready system
          </h2>
          <p className="text-xl text-zinc-600" data-id="element-313" data-mp="3c4fhos59z452">
            Six complete coaching volumes. One connected MMA development pathway.
          </p>
          <p className="font-display font-extrabold uppercase tracking-wide text-sm text-violet-900 mt-3" data-id="element-314" data-mp="3pwc90tz4da0e">
            100% Visual • Ready to open &amp; use
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-315" data-mp="2xd5kf2v7z94t">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-violet-600 shadow-lg shadow-violet-900/10' : 'border-zinc-200 shadow-sm'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-316" data-mp="2sf3z0babmxq6" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-38px] bg-amber-400 text-zinc-950 font-display font-extrabold text-xs py-1 px-10 rotate-45 shadow" data-id="element-317" data-mp="1vg98qmyhasf1">
                  MOST POPULAR
                </div>}

              <div className="mb-5 pr-12" data-id="element-318" data-mp="24eb5urf3d0x1">
                <div className="text-violet-900 font-display font-extrabold text-sm uppercase tracking-wider" data-id="element-319" data-mp="3buioisonn8u9">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-black uppercase leading-tight mt-1 text-zinc-950" data-id="element-320" data-mp="3fxfa8s9hrl2f">
                  {volume.title}
                </h3>
                {volume.eyebrow && <p className="text-violet-600 font-display font-extrabold text-sm uppercase tracking-wide mt-2" data-id="element-321" data-mp="1btu4sih0433d">
                    {volume.eyebrow}
                  </p>}
              </div>

              <p className="text-zinc-950 font-semibold mb-5 border-l-4 border-violet-600 pl-4" data-id="element-322" data-mp="1kql6baeboa5c">
                {volume.subtitle}
              </p>

              <div className="space-y-3 mb-5" data-id="element-323" data-mp="t2jh0a6ko6fp">
                {volume.intro.map(paragraph => <p key={paragraph} className="text-zinc-700 text-sm leading-relaxed" data-id="element-324" data-mp="16teujzs0nbpm">
                    {paragraph}
                  </p>)}
              </div>

              {volume.flow && <div className="mb-6" data-id="element-325" data-mp="eardqwk1yiuc">
                  {volume.flowLabel && <p className="text-sm font-semibold text-zinc-950 mb-2" data-id="element-326" data-mp="9chh0hioja6m">{volume.flowLabel}</p>}
                  <FlowSteps steps={volume.flow} align="start" data-id="element-327" data-mp="2kz1e82ma8yfn" />
                </div>}

              <div className="mb-6 flex-grow" data-id="element-328" data-mp="2psm57apgks5c">
                {volume.bulletsLabel && <h4 className="font-sans text-sm font-bold text-zinc-500 uppercase tracking-wider mb-3" data-id="element-329" data-mp="2c1hg32jpvi99">
                    {volume.bulletsLabel}
                  </h4>}
                <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-330" data-mp="34pwp98g636co">
                  {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-331" data-mp="38o2to9tj99uf">
                      <CheckCircle2 size={18} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-332" data-mp="2upmf5wpfif1q" />
                      <span className="text-zinc-700 text-sm" data-id="element-333" data-mp="2znnuq7nnbw8g">{bullet}</span>
                    </li>)}
                </ul>

                {volume.afterFlow && <div className="mt-6" data-id="element-334" data-mp="1ob4vos7abt1s">
                    <FlowSteps steps={volume.afterFlow} align="start" data-id="element-335" data-mp="1o7za3mxv79at" />
                    {volume.afterText && <p className="text-zinc-700 text-sm leading-relaxed mt-3" data-id="element-336" data-mp="1ytigci8ln8uw">{volume.afterText}</p>}
                  </div>}
              </div>

              <div className="bg-violet-50 border border-violet-100 rounded-xl p-4 mt-auto" data-id="element-337" data-mp="1upaucstj070d">
                <span className="text-violet-900 font-display font-extrabold uppercase text-sm block mb-1" data-id="element-338" data-mp="1pqr4wifq4d39">
                  Result
                </span>
                <p className="text-zinc-800 text-sm" data-id="element-339" data-mp="2iikjk5g4wqic">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}